angular.module('app.filters').filter('timestamp', function($filter) {
    const dateFilter = $filter('date');

    return function(ts) {
        if (ts == null) { return ''; }
        return dateFilter(new Date(ts), 'MM/dd/yyyy hh:mm:ss a');
    };
});


// WEBPACK FOOTER //
// ./filters/timestamp.js